import { gsap } from 'gsap' ;
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { TextPlugin } from 'gsap/TextPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';


export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el entradas');

    gsap.registerPlugin(ScrollTrigger, CSSPlugin, TextPlugin, ScrollToPlugin);

    const varUrl = $('#seccionSuperior a.btn-comprar').first().attr('href');

    if (varUrl) {
      $('a.btnEntradas').attr('href', varUrl);
    }

   /* var tl = gsap.timeline();
    tl.fromTo('.header-promocion',
      {width: 0, opacity: 0},
      {width: '100%', opacity: 1});
      tl.fromTo('.btn-promocion',
      {width: 0, opacity: 0},
      {width: '100%', opacity: 1})
    

    

    ScrollTrigger.create({
      animation: tl,
      trigger: '#seccion-promociones',
      start: '5% 80%',
      end: '75% 70%',
      scrub: 1,
    }) */


    $('.popupFamilias').animate({
        'opacity' : '1',
        'height' : '100%',
        'top' : 0,
        'left': 0,
        'width' : '100%',
      }, 1000);

    function cerrarPopUp () {
      $('.popupFamilias').animate({
        'opacity' : '0',
        'height' : '0',
        'top' : '-100vh',
        'left': '-100vw',
        'width' : '0',
      }, 500);
    }

    $('#cerrar').on('click',function(){
      cerrarPopUp ();
    });

    setTimeout(function() {
      var ventana_ancho = $(window).width();
      if (ventana_ancho < 980) {
        cerrarPopUp ();
      }
    }, 5000)

 
    $('.linkespecial').on('click', function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
              $('html,body').animate({
                  scrollTop: target.offset().top - 200,
              }, 200);
              return false;
          }
      }
  });
  


    // let prevUrl = document.referrer;

   
    // console.log(prevUrl);

    //   $('a[href*=#]').click(function() {
    //     let varAlturaMenu = $('.banner').height();
    //     if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
    //     && location.hostname == this.hostname) {
    //       var $target = $(this.hash);
    //       $target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
    //       if ($target.length) {
    //         var targetOffset = $target.offset().top - varAlturaMenu;
    //         console.log(targetOffset);
    //         $('html,body').animate({scrollTop: targetOffset}, 800);
    //         return false;
    //       }
    //     }
    //   });



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-entradas.js